import { Controller } from "@hotwired/stimulus"

// Inline title editing on report detail screens. Clicking the pencil swaps
// the heading for an input; Enter (or Save) submits, Escape cancels.
// Mounted via data-controller="inline-edit".
export default class extends Controller {
  static targets = ["display", "form", "input"]

  edit() {
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }

  keydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }
  }
}
